import React from 'react'

import {handleChange} from '../modules/functions.js'
import icon_trash from '../images/icon-trash.svg';

const e = React.createElement;

// todo: maxlength processing

function Metadata(props) {
  React.Component.constructor.call(this);

  this.state = {metadata_add_text:"", metadata_add_type:"1"};
}
Metadata.prototype = Object.create(React.Component.prototype);


Metadata.prototype.render = function() {
  const item_metadata = this.props.item_metadata;
  
  var metadata = null;
  if(item_metadata) {
    var item_metadata_array = item_metadata.split(";;");
    metadata = item_metadata_array.map(function(metadata, i) {
      metadata = JSON.parse(metadata);
      var metadata_text = metadata.text;
      var metadata_type = "Invalid type"; // todo: i18n
      if(metadata.type === "0") {
        metadata_type = "Other";
      } else if(metadata.type === "1") {
        metadata_type = "Name";
      } else if(metadata.type === "2") {
        metadata_type = "Email";
        metadata_text = e('a', {href:"mailto:"+metadata.text, target:"_blank", rel:"noopener noreferrer"}, metadata.text);
      } else if(metadata.type === "3") {
        metadata_type = "Website";
        var linked = metadata.text;
        if(!linked.startsWith("http")) linked = "https://"+linked;
        metadata_text = e('a', {href:linked, target:"_blank", rel:"noopener noreferrer"}, linked);
      } else if(metadata.type === "4") {
        metadata_type = "Phone number";
        metadata_text = e('a', {href:"tel:"+metadata.text, target:"_blank", rel:"noopener noreferrer"}, metadata.text);
      } else if(metadata.type === "5") {
        metadata_type = "Adress";
      } else if(metadata.type === "6") {
        metadata_type = "Note";
      } else if(metadata.type === "7") {
        metadata_type = "Twitter";
        var link_parts = metadata.text.split("/");
        var cleaned = link_parts.pop();
        if(cleaned === "") cleaned = link_parts.pop();
        metadata_text = e('a', {href:"https://twitter.com/"+cleaned, target:"_blank", rel:"noopener noreferrer"}, "@"+cleaned);
      } else if(metadata.type === "8") {
        metadata_type = "LinkedIn";
        var link_parts = metadata.text.split("/");
        var cleaned = link_parts.pop();
        if(cleaned === "") cleaned = link_parts.pop();
        metadata_text = e('a', {href:"https://www.linkedin.com/in/"+cleaned, target:"_blank", rel:"noopener noreferrer"}, "/in/"+cleaned);
      }
      return e('div', {key:"1_"+i, style:{marginBottom:"15px"}}, [
        e('div', {key:"tpe", style:{fontSize:"70%", position:"relative"}}, [
          metadata_type,
          e('span', {key:"rem", className:"clickable-text", style:{fontSize:"200%", position:"absolute", right:"0", cursor:"pointer"}, onClick:this.handleRemoveMetadata.bind(this, {type:metadata.type, text:metadata.text})}, e('img', {src:icon_trash, alt:"Delete"}))
          ]),
        e('span', {key:"txt", style:{marginRight:"20px"}}, metadata_text)
      ]);
    }.bind(this));
  }
  // todo: i18n
  var addbtn_txt = "add "+this.state.metadata_add_text;
  if(this.state.metadata_add_text.length > 40) {
    addbtn_txt = "add "+this.state.metadata_add_text.substring(0,40)+"..";
  }
  var md_add_type = e('select', {key:"tpe", value:this.state.metadata_add_type, onChange:handleChange.bind(null, this, "metadata_add_type")}, [
    e('option', {key:"1", value:"1"}, "Name"),
    e('option', {key:"2", value:"2"}, "Email"),
    e('option', {key:"3", value:"3"}, "Website"),
    e('option', {key:"4", value:"4"}, "Phone number"),
    e('option', {key:"5", value:"5"}, "Adress"),
    e('option', {key:"6", value:"6"}, "Note"),
    e('option', {key:"7", value:"7"}, "Twitter"),
    e('option', {key:"8", value:"8"}, "LinkedIn"),
    e('option', {key:"0", value:"0"}, "Other"),
  ]);
  if(this.props.multi && this.props.multi === "Links") {
    md_add_type = null;
  }

  var input_placeholder = "text";
  if(this.props.multi && this.props.multi === "Links") {
    input_placeholder = "Link URL";
  }

  var new_metadata = {type:this.state.metadata_add_type, text:this.state.metadata_add_text};
  if(this.props.multi && this.props.multi === "Links") {
    new_metadata = {type:"3", text:this.state.metadata_add_text};
  }

  var metadata_add = e('div', {key:"add", className:(this.props.multi ? "" : "contact-labels editmode")}, [
    e('input', {key:"txt", type:"text", placeholder:input_placeholder, maxLength:"256", value:this.state.metadata_add_text, onChange:handleChange.bind(null, this, "metadata_add_text")}),
    md_add_type,
    e('button', {key:"addbtn", type:"button", className:"btn btn-e", style:{width:"100%", textAlign:"center", marginTop:"7px"}, onClick:this.handleAddMetadata.bind(this, new_metadata)}, addbtn_txt),
  ]);
  var header = "Contact info";
  if(this.props.multi) header = this.props.multi;
  if(metadata && metadata_add) {
    return e('div', {className:"contact-metadata"}, [e('div', {key:"header", style:{marginBottom:"7px", fontSize:"85%"}}, header), metadata, metadata_add]);
  } else if(metadata) {
    return e('div', {className:"contact-metadata"}, [e('div', {key:"header", style:{marginBottom:"7px", fontSize:"85%"}}, header), metadata]);
  } else if(metadata_add) {
    return e('div', {className:"contact-metadata"}, [e('div', {key:"header", style:{marginBottom:"7px", fontSize:"85%"}}, header), metadata_add]);
  } else {
    return null;
  }
}

Metadata.prototype.handleAddMetadata = function(metadata_json) {
  if(metadata_json.text !== "" && metadata_json.text.indexOf(";;") === -1) {
    metadata_json = JSON.stringify(metadata_json);
    var new_item_metadata = "";

    if(this.props.item_metadata === "" || this.props.item_metadata === undefined) {
      new_item_metadata = metadata_json;
    } else {
      new_item_metadata = this.props.item_metadata + ";;" + metadata_json;
    }

    this.setState({metadata_add_text:"", metadata_add_type:"1"});

    this.props.updateMetadata(this.props.item_metadata_sn, new_item_metadata);
  }
}

Metadata.prototype.handleRemoveMetadata = function(metadata_json) {
  metadata_json = JSON.stringify(metadata_json);
  var new_item_metadata = "";

  new_item_metadata = this.props.item_metadata.split(";;").filter(function(_metadata_json) {
    return _metadata_json !== metadata_json;
  }).join(';;');

  this.props.updateMetadata(this.props.item_metadata_sn, new_item_metadata);
}


export default Metadata



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/Metadata.js
// module id = 226
// module chunks = 0